import { render, staticRenderFns } from "./WeeklyTrend.vue?vue&type=template&id=15d89812&scoped=true"
import script from "./WeeklyTrend.vue?vue&type=script&lang=js"
export * from "./WeeklyTrend.vue?vue&type=script&lang=js"
import style0 from "./WeeklyTrend.vue?vue&type=style&index=0&id=15d89812&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d89812",
  null
  
)

export default component.exports